'use client';

import Link from 'next/link';
import { useState } from 'react';
import { Button } from "@/components/ui/button"
import { toast } from "sonner"
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { emailField } from '@/validations/validators';
import { useTheme } from "next-themes"
import { signIn, signOut } from 'aws-amplify/auth';
import { InputOtpLogin } from '@/components/input-otp';
import { Loader2, Mail } from 'lucide-react';
import { InputWithIcon } from '@/components/ui/input-icon';
import Errors from '@/services/cognito/errors';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card"

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false)

  const { theme } = useTheme()
  const form = useForm({
    resolver: zodResolver(emailField),
    defaultValues: {
      email: '',
    },
  })

  const handleSendCode = async (values) => {
    try {
      setLoading(true);

      await signOut()

      const { nextStep } = await signIn({
        username: values.email,
        options: {
          authFlowType: 'CUSTOM_WITHOUT_SRP',
        },
      });

      if (nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE") {
        toast.success("Código enviado para o seu e-mail e telefone cadastrado!", {
          duration: 8000
        });

        setShowOtpModal(true)
        return;
      }

    } catch (err) {
      console.error("LoginPage", err)
      toast.error(Errors[err.name] ?? Errors["DefaultError"]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="hover:scale-none w-full max-w-sm sm:max-w-md md:max-w-md mx-auto bg-background text-foreground">
      <CardHeader>
        <CardTitle className="text-xl sm:text-2xl md:text-3xl font-bold text-center">Seja Bem-vindo(a)!</CardTitle>
        <div className="text-center text-xs sm:text-sm md:text-base">
          Não tem uma conta?{" "}
          <Link
            href={`/register`}
            className="font-medium underline-offset-4 underline"
          >
            Cadastre-se
          </Link>
        </div>
      </CardHeader>

      <CardContent>
        <Form {...form}>
          <form
            className="flex flex-col gap-4 sm:gap-5 md:gap-6"
            onSubmit={form.handleSubmit(handleSendCode)}
          >
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>E-mail<span className="text-red-500">*</span></FormLabel>
                  <FormControl>
                    <InputWithIcon
                      id="email"
                      placeholder="Informe seu e-mail"
                      {...field}
                      icon={Mail}
                      type="email"
                      className="text-sm sm:text-base md:text-lg"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button
              type="submit"
              disabled={loading}
              className="cursor-pointer w-full md:w-auto min-w-32 sm:min-w-36 md:min-w-40 text-sm sm:text-base"
            >
              Entrar
              {loading && <Loader2 className="h-4 w-4 animate-spin ml-2" />}
            </Button>

            {showOtpModal && (
              <InputOtpLogin onClose={() => setShowOtpModal(false)} />
            )}
          </form>
        </Form>
      </CardContent>
    </Card>
  )
}






// "use client";

// import Link from 'next/link';
// import { useState, useEffect } from 'react';
// import { Button } from "@/components/ui/button"
// import { toast } from "sonner"
// import { useForm } from "react-hook-form";
// import { zodResolver } from "@hookform/resolvers/zod";
// import {
//   Form,
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from "@/components/ui/form"
// import { emailField } from '@/validations/validators';
// import { useTheme } from "next-themes"
// import { signIn, signOut } from 'aws-amplify/auth';
// import { InputOtpLogin } from '@/components/input-otp';
// import { Loader2, Mail } from 'lucide-react';
// import { InputWithIcon } from '@/components/ui/input-icon';
// import Errors from '@/services/cognito/errors';


// export default function LoginPage() {
//   const [loading, setLoading] = useState(false);
//   const [showOtpModal, setShowOtpModal] = useState(false)

//   const { theme } = useTheme()
//   const form = useForm({
//     resolver: zodResolver(emailField),
//     defaultValues: {
//       email: '',
//     },
//   })

//   const handleSendCode = async (values) => {
//     try {
//       setLoading(true);

//       await signOut()

//       const { nextStep } = await signIn({
//         username: values.email,
//         options: {
//           authFlowType: 'CUSTOM_WITHOUT_SRP',
//         },
//       });


//       if (nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE") {
//         toast.success("Código enviado para o seu e-mail e para o seu telefone cadastrado!", {
//           duration: 8000
//         });

//         setShowOtpModal(true)
//         return;
//       }

//     } catch (err) {
//       console.error("LoginPage", err)
//       toast.error(Errors[err.name] ?? Errors["DefaultError"]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
//       <div className="w-full max-w-sm md:max-w-md flex">
//         <Form {...form}>
//           <form
//             className="flex flex-col gap-4 bg-card p-6 md:p-8 rounded-xl shadow-lg w-full"
//             onSubmit={form.handleSubmit(handleSendCode)}
//           >
//             <div className="flex flex-col items-center gap-2">
//               <a href="#" className="flex flex-col items-center gap-2 font-medium">
//                 <span className="sr-only">Power2Go</span>
//               </a>
//               <h1 className="text-xl font-bold">Seja Bem-vindo(a)!</h1>
//               <div className="text-center text-sm">
//                 Não tem uma conta?{" "}
//                 <Link
//                   href={`/register`}
//                   className="text-sm font-medium hover:underline break-words whitespace-normal max-w-xs underline underline-offset-4"
//                 >
//                   Cadastre-se
//                 </Link>
//               </div>
//             </div>
//             <FormField
//               control={form.control}
//               name="email"
//               render={({ field }) => (
//                 <FormItem>
//                   <FormLabel>E-mail<span className="text-red-500">*</span></FormLabel>
//                   <FormControl>
//                     <InputWithIcon id="email" placeholder="Informe seu e-mail" {...field} icon={Mail} type="email" />
//                   </FormControl>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />
//             <Button
//               type="submit"
//               disabled={loading}
//               className="w-full cursor-pointer"
//             >
//               Entrar
//               {loading && <Loader2 className="h-4 w-4 animate-spin" />}
//             </Button>
//             {showOtpModal && (
//               <InputOtpLogin onClose={() => setShowOtpModal(false)} />
//             )}
//           </form>
//         </Form>
//       </div>
//     </div >
//   )
// }
